import React from "react";

interface GridTableProps {
	head: string[];
	rows: Array<Array<string>>;
	caption?: string;
	scroll?: boolean;
}

function GridTable({rows, head, caption, scroll = true}: GridTableProps) {
	return (
		<div
			className={`scrollbar:h-[5px] scrollbar-track:bg-leo-divider-gray scrollbar-thumb:bg-leo-dark-brown ${
				scroll ? "overflow-x-scroll" : "overflow-x-hidden"
			}
    md:scrollbar:hidden
    `}
		>
			<table
				className={`shadow-md text-left mb-5 w-full whitespace-nowrap md:shadow-none`}
			>
				<thead className="">
				<tr className="bg-leo-button-gray md:bg-white">
					{head.map((headName, idx) => (
						<th
							scope="col"
							key={idx}
							className={`px-4 py-2 text-white text-[16px] md:text-black md:text-[20px] md:pb-5 md:first:pl-0 ${
								caption && "md:pb-0"
							}
                ${!scroll && "last:text-right md:last:text-left"}`}
						>
							{headName}
						</th>
					))}
				</tr>
				{caption && (
					<tr>
						<th
							className="pl-4 pt-2 not-italic font-bold md:font-normal md:italic md:text-black md:pb-5 md:pl-0 md:pt-0"
							colSpan={head.length}
						>
							{caption}
						</th>
					</tr>
				)}
				</thead>
				<tbody className={``}>
				{rows.map((row, idx) => {
					return (
						<tr tabIndex={idx} key={idx}>
							{row.map((rowName, idx2) => (
								<td
									className={`first:w-1/2 w-1/4 pl-4 py-2 pr-10 border-leo-light-gray  ${
										idx > 0 && idx < 2 && "border-y-2 border-collapse"
									} ${idx2 > 0 && "text-leo-blue font-bold"}
                    md:border-none md:text-[18px] md:pb-[10px] md:pt-0 md:first:pl-0 first-letter:
                    ${
										!scroll &&
										"first:whitespace-normal first:pr-2 last:whitespace-normal last:align-bottom last:text-right last:min-w-[90px] last:pr-4 md:last:text-left md:last:whitespace-nowrap md:first:pr-4"
									}
                    ${idx2 === 0 && "min-w-[225px]"}
                    `}
									key={idx2}
								>
									{rowName}
								</td>
							))}
						</tr>
					);
				})}
				</tbody>
			</table>
		</div>
	);
}

export default GridTable;
